import React from 'react';
import { cn } from '@/lib/utils';
import Logo from './Logo';

interface AuthCardProps {
  headerAction?: React.ReactNode;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  banner?: React.ReactNode;
  /** id for the card element, kept so legacy selectors (e.g. `#login-box`) resolve. */
  cardId?: string;
  className?: string;
}

export function AuthCard({ headerAction, title, children, footer, banner, cardId, className }: AuthCardProps) {
  return (
    // No <main> here: the Rails layout already renders the `#main role="main"`
    // landmark, and a second one trips axe's landmark-unique rule.
    <div className={cn('flex min-h-screen flex-col bg-neutral-100 font-sans', className)}>
      <header className="flex h-16 items-center justify-between border-b border-neutral-300 bg-neutral-000 px-6 sm:px-16">
        <a href="/" aria-label="Ably home" className="focus-base rounded-md">
          <Logo className="block" />
        </a>
        {headerAction}
      </header>

      <div className="flex flex-1 items-center justify-center px-6 py-10 sm:py-12 md:py-16 lg:py-20">
        <div className="w-full max-w-auth-card">
          <div id={cardId} className="rounded-2xl border border-neutral-300 bg-neutral-000 p-6 sm:p-10">
            <h1 className="text-center text-2xl font-bold tracking-tight text-neutral-1300">{title}</h1>
            <div className="mt-6">{children}</div>
          </div>
          {footer ? <div className="mt-6">{footer}</div> : null}
          {banner ? <div className="mt-6">{banner}</div> : null}
        </div>
      </div>
    </div>
  );
}

export default AuthCard;
